export const label = {
  'de-DE': 'Schließen',
  'nl-NL': 'Sluiten',
  'zh-TW': '關閉',
  ar: 'إغلاق',
  az: 'Bağla',
  be: 'Закрыць',
  bg: 'Затвори',
  bs: 'Zatvori',
  cnr: 'Zatvori',
  cs: 'Zavřít',
  da: 'Luk',
  de: 'Schließen',
  el: 'Κλείσιμο',
  en: 'Close',
  es: 'Cerrar',
  et: 'Sulge',
  fi: 'Sulje',
  fr: 'Fermer',
  he: 'סגור',
  hr: 'Zatvori',
  hu: 'Bezárás',
  hy: 'Փակել',
  id: 'Tutup',
  is: 'Loka',
  it: 'Chiudi',
  ja: '閉じる',
  ka: 'დახურვა',
  ko: '닫기',
  lt: 'Uždaryti',
  lv: 'Aizvērt',
  mk: 'Затвори',
  nl: 'Sluiten',
  no: 'Lukk',
  pl: 'Zamknij',
  pt: 'Fechar',
  ro: 'Închide',
  ru: 'Закрыть',
  sk: 'Zavrieť',
  sl: 'Zapri',
  sq: 'Mbyll',
  sr: 'Zatvori',
  sv: 'Stäng',
  th: 'ปิด',
  tr: 'Kapat',
  uk: 'Закрити',
  vi: 'Đóng',
  zh: '关闭',
};
